(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocoes-collection-showcase-gated"] && !Shopify.designMode) return;
  try {
    
  class CocoesCollectionShowcase extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('cancel', this.handleCancel);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('cancel', this.handleCancel);
    }

    handleClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const closeButton = target.closest('[data-cocoes-modal-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-cocoes-product-modal]');
        this.closeDialog(dialog);
        return;
      }

      if (target instanceof HTMLDialogElement && target.matches('[data-cocoes-product-modal]')) {
        this.closeDialog(target);
        return;
      }

      const modalButton = target.closest('[data-cocoes-modal-trigger]');
      const trigger = modalButton || target.closest('[data-cocoes-product-card]');
      if (!trigger) return;

      if (!modalButton && target.closest('form, button, a, input, select, textarea, label')) return;

      const card = trigger.closest('[data-cocoes-product-card]');
      const dialogId = card?.getAttribute('data-cocoes-modal-id');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      this.openDialog(dialog);
    };

    handleCancel = (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-cocoes-product-modal]')) return;

      event.preventDefault();
      this.closeDialog(dialog);
    };

    openDialog(dialog) {
      if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

      dialog.removeAttribute('data-closing');
      dialog.showModal();
    }

    closeDialog(dialog) {
      if (!(dialog instanceof HTMLDialogElement) || !dialog.open || dialog.dataset.closing === 'true') return;

      dialog.dataset.closing = 'true';
      const finishClose = () => {
        dialog.close();
        dialog.removeAttribute('data-closing');
      };

      dialog.addEventListener('animationend', finishClose, { once: true });
    }
  }

  if (!customElements.get('cocoes-collection-showcase')) {
    customElements.define('cocoes-collection-showcase', CocoesCollectionShowcase);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  class CocoesCollectionShowcase extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('cancel', this.handleCancel);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('cancel', this.handleCancel);
    }

    handleClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const closeButton = target.closest('[data-cocoes-modal-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-cocoes-product-modal]');
        this.closeDialog(dialog);
        return;
      }

      if (target instanceof HTMLDialogElement && target.matches('[data-cocoes-product-modal]')) {
        this.closeDialog(target);
        return;
      }

      const modalButton = target.closest('[data-cocoes-modal-trigger]');
      const trigger = modalButton || target.closest('[data-cocoes-product-card]');
      if (!trigger) return;

      if (!modalButton && target.closest('form, button, a, input, select, textarea, label')) return;

      const card = trigger.closest('[data-cocoes-product-card]');
      const dialogId = card?.getAttribute('data-cocoes-modal-id');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      this.openDialog(dialog);
    };

    handleCancel = (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-cocoes-product-modal]')) return;

      event.preventDefault();
      this.closeDialog(dialog);
    };

    openDialog(dialog) {
      if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

      dialog.removeAttribute('data-closing');
      dialog.showModal();
    }

    closeDialog(dialog) {
      if (!(dialog instanceof HTMLDialogElement) || !dialog.open || dialog.dataset.closing === 'true') return;

      dialog.dataset.closing = 'true';
      const finishClose = () => {
        dialog.close();
        dialog.removeAttribute('data-closing');
      };

      dialog.addEventListener('animationend', finishClose, { once: true });
    }
  }

  if (!customElements.get('cocoes-collection-showcase')) {
    customElements.define('cocoes-collection-showcase', CocoesCollectionShowcase);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.cocoesInitialized === 'true') return;
      section.dataset.cocoesInitialized = 'true';

      const variantsScript = section.querySelector('[data-cocoes-variants]');
      const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
      const form = section.querySelector('.cocoes-product-form form');
      const variantInput = form?.querySelector('input[name="id"]');
      const addButton = form?.querySelector('[name="add"]');
      const price = section.querySelector('[data-cocoes-price]');
      const mediaTrack = section.querySelector('[data-cocoes-media-track]');
      const thumbs = [...section.querySelectorAll('.cocoes-thumb')];

      const formatMoney = (cents) => {
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, section.dataset.moneyFormat);
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: Shopify.currency?.active || 'USD' }).format(cents / 100);
      };

      const setActiveMedia = (id, scroll = true) => {
        if (!id) return;
        thumbs.forEach((thumb) => {
          const active = thumb.dataset.mediaId === String(id);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        const slide = section.querySelector(`.cocoes-media-slide[data-media-id="${id}"]`);
        if (slide && scroll) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      };

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => setActiveMedia(thumb.dataset.mediaId)));

      if (mediaTrack) {
        mediaTrack.addEventListener('scroll', () => {
          window.clearTimeout(mediaTrack._cocoesScrollTimer);
          mediaTrack._cocoesScrollTimer = window.setTimeout(() => {
            const slides = [...mediaTrack.querySelectorAll('.cocoes-media-slide')];
            const current = slides.reduce((nearest, slide) => {
              const distance = Math.abs(slide.getBoundingClientRect().left - mediaTrack.getBoundingClientRect().left);
              return !nearest || distance < nearest.distance ? { slide, distance } : nearest;
            }, null);
            if (current?.slide) setActiveMedia(current.slide.dataset.mediaId, false);
          }, 80);
        });
      }

      const updateVariant = () => {
        if (!variants.length || !variantInput) return;
        const selectedOptions = [...section.querySelectorAll('[data-cocoes-variant-picker] input:checked')]
          .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
          .map((input) => input.value);
        const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
        if (!variant) return;

        variantInput.value = variant.id;
        variantInput.disabled = !variant.available;
        if (addButton) {
          addButton.disabled = !variant.available;
          const text = addButton.querySelector('.add-to-cart-text__content span span');
          if (text) text.textContent = variant.available ? 'Add to Cart' : 'Coming soon';
        }
        if (price) {
          const compare = variant.compare_at_price && variant.compare_at_price > variant.price
            ? `<span class="compare-at-price">${formatMoney(variant.compare_at_price)}</span> `
            : '';
          price.innerHTML = `<div ref="priceContainer">${compare}<span class="price">${formatMoney(variant.price)}</span></div>`;
        }
        section.querySelectorAll('quantity-selector-component').forEach((quantitySelector) => {
          quantitySelector.dataset.variantId = variant.id;
          const input = quantitySelector.querySelector('input[name="quantity"]');
          if (input) {
            input.disabled = !variant.available;
            input.value = Math.max(Number(input.min) || 1, 1);
          }
        });
        if (variant.featured_media?.id) setActiveMedia(variant.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      section.querySelectorAll('[data-cocoes-variant-picker] input').forEach((input) => {
        input.addEventListener('change', updateVariant);
      });

      section.querySelectorAll('[data-cocoes-accordion] .cocoes-accordion-button').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = section.querySelector(`#${button.getAttribute('aria-controls')}`);
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          panel?.setAttribute('aria-hidden', expanded ? 'true' : 'false');
        });
      });

      const recTrack = section.querySelector('[data-cocoes-recs-track]');
      section.querySelector('[data-cocoes-recs-prev]')?.addEventListener('click', () => {
        recTrack?.scrollBy({ left: -Math.max(260, recTrack.clientWidth * 0.7), behavior: 'smooth' });
      });
      section.querySelector('[data-cocoes-recs-next]')?.addEventListener('click', () => {
        recTrack?.scrollBy({ left: Math.max(260, recTrack.clientWidth * 0.7), behavior: 'smooth' });
      });

      section.querySelectorAll('[data-cocoes-rec-form]').forEach((recForm) => {
        recForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = recForm.querySelector('button');
          button.disabled = true;
          button.dataset.originalText = button.textContent;
          button.textContent = 'Adding...';
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: new FormData(recForm)
            });
            const item = await response.json();
            const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: recForm.id, data: { source: 'cocoes-product-main', variantId: item.id } }
            }));
            button.textContent = 'Added';
            setTimeout(() => { button.textContent = button.dataset.originalText || 'Add to Cart'; }, 1200);
          } catch (error) {
            button.textContent = 'Try Again';
          } finally {
            setTimeout(() => { button.disabled = false; }, 600);
          }
        });
      });
    };

    const initAll = () => document.querySelectorAll('.cocoes-product-page').forEach(init);
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.cocoes-product-page')));
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-recipe-index-controls"] && !Shopify.designMode) return;
  try {
    
  const initCocoesRecipeIndexControls = () => {
    document.querySelectorAll('[data-cocoes-recipe-index-controls]').forEach((section) => {
      if (section.dataset.cocoesRecipeIndexControlsInitialized === 'true') return;
      section.dataset.cocoesRecipeIndexControlsInitialized = 'true';

      const input = section.querySelector('[data-cocoes-recipe-search-input]');
      const buttons = Array.from(section.querySelectorAll('[data-cocoes-recipe-filter]'));

      const publish = (query) => {
        const normalizedQuery = query.trim().toLowerCase();
        buttons.forEach((button) => {
          button.classList.toggle('is-active', (button.dataset.filterQuery || '') === normalizedQuery);
        });
        document.dispatchEvent(new CustomEvent('cocoes:recipe-search', { detail: { query: normalizedQuery } }));
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const query = button.dataset.filterQuery || '';
          if (input) input.value = query;
          publish(query);
        });
      });

      if (input) {
        input.addEventListener('input', () => publish(input.value));
        input.addEventListener('search', () => publish(input.value));
      }

      document.addEventListener('cocoes:recipe-search', (event) => {
        const normalizedQuery = (event.detail.query || '').trim().toLowerCase();
        if (input && input.value.trim().toLowerCase() !== normalizedQuery) {
          input.value = normalizedQuery;
        }
        buttons.forEach((button) => {
          button.classList.toggle('is-active', (button.dataset.filterQuery || '') === normalizedQuery);
        });
      });
    });
  };

  initCocoesRecipeIndexControls();
  document.addEventListener('shopify:section:load', initCocoesRecipeIndexControls);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-recipe-index-featured"] && !Shopify.designMode) return;
  try {
    
  const initCocoesRecipeIndexFeatured = () => {
    document.querySelectorAll('[data-cocoes-recipe-index-featured]').forEach((section) => {
      if (section.dataset.cocoesRecipeIndexFeaturedInitialized === 'true') return;
      section.dataset.cocoesRecipeIndexFeaturedInitialized = 'true';

      document.addEventListener('cocoes:recipe-search', (event) => {
        section.hidden = Boolean(event.detail.query);
      });
    });
  };

  initCocoesRecipeIndexFeatured();
  document.addEventListener('shopify:section:load', initCocoesRecipeIndexFeatured);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-recipe-index-grid"] && !Shopify.designMode) return;
  try {
    
  const initCocoesRecipeIndexGrid = () => {
    document.querySelectorAll('[data-cocoes-recipe-index-grid-section]').forEach((section) => {
      if (section.dataset.cocoesRecipeIndexGridInitialized === 'true') return;
      section.dataset.cocoesRecipeIndexGridInitialized = 'true';

      const searchResults = section.querySelector('[data-cocoes-recipe-search-results]');
      const searchGrid = section.querySelector('[data-cocoes-recipe-search-grid]');
      const recipeGrid = section.querySelector('[data-cocoes-recipe-grid]');
      const loadMoreButton = section.querySelector('[data-cocoes-recipe-load-more]');
      const empty = section.querySelector('[data-cocoes-recipe-empty]');

      const cards = Array.from(section.querySelectorAll('[data-cocoes-recipe-card]')).sort((a, b) =>
        (a.dataset.recipeTitle || '').localeCompare(b.dataset.recipeTitle || '')
      );
      const initiallyHiddenCards = cards.slice(8);
      let recipesExpanded = initiallyHiddenCards.length === 0;

      const resetGrid = () => {
        cards.forEach((card) => {
          card.hidden = false;
          if (recipeGrid) recipeGrid.appendChild(card);
        });

        if (!recipesExpanded) {
          initiallyHiddenCards.forEach((card) => {
            card.hidden = true;
          });
        }

        if (searchResults) searchResults.hidden = true;
        if (recipeGrid) recipeGrid.hidden = false;
        if (empty) empty.hidden = true;
        if (loadMoreButton) loadMoreButton.hidden = recipesExpanded;
      };

      const filterGrid = (query, productHandle = '') => {
        const normalizedQuery = query.trim().toLowerCase();
        const normalizedProductHandle = productHandle.trim().toLowerCase();

        if (!normalizedQuery && !normalizedProductHandle) {
          resetGrid();
          return;
        }

        let visibleCards = 0;
        if (searchGrid) searchGrid.textContent = '';
        if (recipeGrid) recipeGrid.hidden = true;
        if (loadMoreButton) loadMoreButton.hidden = true;

        cards
          .filter((card) => {
            if (normalizedProductHandle) {
              return (card.dataset.recipeProducts || '').includes(`,${normalizedProductHandle},`);
            }

            return (card.dataset.recipeSearch || '').includes(normalizedQuery);
          })
          .forEach((card) => {
            card.hidden = false;
            if (searchGrid) searchGrid.appendChild(card);
            visibleCards += 1;
          });

        if (searchResults) searchResults.hidden = visibleCards === 0;
        if (empty) empty.hidden = visibleCards > 0;
      };

      if (loadMoreButton) {
        loadMoreButton.hidden = recipesExpanded;
        loadMoreButton.addEventListener('click', () => {
          recipesExpanded = true;
          cards.forEach((card) => {
            card.hidden = false;
          });
          loadMoreButton.hidden = true;
        });
      }

      document.addEventListener('cocoes:recipe-load-more', () => {
        recipesExpanded = true;
        cards.forEach((card) => {
          card.hidden = false;
        });
        if (loadMoreButton) loadMoreButton.hidden = true;
      });

      if (!recipesExpanded) {
        initiallyHiddenCards.forEach((card) => {
          card.hidden = true;
        });
      }

      document.addEventListener('cocoes:recipe-search', (event) => {
        filterGrid(event.detail.query || '', event.detail.productHandle || '');
      });
    });
  };

  initCocoesRecipeIndexGrid();
  document.addEventListener('shopify:section:load', initCocoesRecipeIndexGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-recipe-index-products"] && !Shopify.designMode) return;
  try {
    
  const initCocoesRecipeProductLoadMore = () => {
    document.querySelectorAll('[data-cocoes-recipe-load-more-external]').forEach((button) => {
      if (button.dataset.cocoesRecipeLoadMoreInitialized === 'true') return;
      button.dataset.cocoesRecipeLoadMoreInitialized = 'true';

      button.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cocoes:recipe-load-more'));
        button.hidden = true;
      });
    });

    document.querySelectorAll('[data-cocoes-recipe-product-filter]').forEach((card) => {
      if (card.dataset.cocoesRecipeProductFilterInitialized === 'true') return;
      card.dataset.cocoesRecipeProductFilterInitialized = 'true';

      const filterByProduct = () => {
        const query = card.dataset.productQuery || '';
        const productHandle = card.dataset.productHandle || '';
        document.dispatchEvent(new CustomEvent('cocoes:recipe-search', { detail: { query, productHandle } }));
        document.getElementById('cocoes-recipe-index-controls')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      card.addEventListener('click', filterByProduct);
      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        filterByProduct();
      });
    });
  };

  initCocoesRecipeProductLoadMore();
  document.addEventListener('shopify:section:load', initCocoesRecipeProductLoadMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoes-recipe-index"] && !Shopify.designMode) return;
  try {
    
  const initCocoesRecipeIndexes = () => {
    document.querySelectorAll('[data-cocoes-recipe-index]').forEach((section) => {
      if (section.dataset.cocoesRecipeIndexInitialized === 'true') return;
      section.dataset.cocoesRecipeIndexInitialized = 'true';

      const searchInput = section.querySelector('[data-cocoes-recipe-search]');
      const groups = Array.from(section.querySelectorAll('[data-cocoes-recipe-group]'));
      const searchResults = section.querySelector('[data-cocoes-recipe-search-results]');
      const searchGrid = section.querySelector('[data-cocoes-recipe-search-grid]');
      const groupsWrapper = section.querySelector('[data-cocoes-recipe-groups]');
      const browseContent = section.querySelector('[data-cocoes-recipe-browse-content]');
      const filterButtons = Array.from(section.querySelectorAll('[data-cocoes-recipe-filter]'));
      const loadMoreButton = section.querySelector('[data-cocoes-recipe-load-more]');
      const empty = section.querySelector('[data-cocoes-recipe-empty]');

      groups.forEach((group) => {
        const grid = group.querySelector('[data-cocoes-recipe-grid]');
        if (!grid) return;

        Array.from(grid.querySelectorAll('[data-cocoes-recipe-card]'))
          .sort((a, b) => (a.dataset.recipeTitle || '').localeCompare(b.dataset.recipeTitle || ''))
          .forEach((card) => grid.appendChild(card));
      });

      const cards = Array.from(section.querySelectorAll('[data-cocoes-recipe-card]')).sort((a, b) =>
        (a.dataset.recipeTitle || '').localeCompare(b.dataset.recipeTitle || '')
      );
      const initiallyHiddenCards = cards.slice(8);
      let recipesExpanded = initiallyHiddenCards.length === 0;

      const updateActiveFilter = (query) => {
        filterButtons.forEach((button) => {
          button.classList.toggle('is-active', (button.dataset.filterQuery || '') === query);
        });
      };

      const resetRecipeIndex = () => {
        groups.forEach((group) => {
          const grid = group.querySelector('[data-cocoes-recipe-grid]');
          if (!grid) return;

          cards
            .filter((card) => card.dataset.recipeSection === group.dataset.recipeSection)
            .forEach((card) => {
              card.hidden = false;
              grid.appendChild(card);
            });

          group.hidden = false;
        });

        if (!recipesExpanded) {
          initiallyHiddenCards.forEach((card) => {
            card.hidden = true;
          });
        }

        if (searchResults) searchResults.hidden = true;
        if (groupsWrapper) groupsWrapper.hidden = false;
        if (browseContent) browseContent.hidden = false;
        if (empty) empty.hidden = true;
        if (loadMoreButton) loadMoreButton.hidden = recipesExpanded;
        updateActiveFilter('');
      };

      const handleRecipeSearch = () => {
        const query = searchInput ? searchInput.value.trim().toLowerCase() : '';

        if (!query) {
          resetRecipeIndex();
          return;
        }

        let visibleCards = 0;
        if (searchGrid) searchGrid.textContent = '';
        if (groupsWrapper) groupsWrapper.hidden = true;
        if (browseContent) browseContent.hidden = true;

        groups.forEach((group) => {
          group.hidden = true;
        });

        cards
          .filter((card) => (card.dataset.recipeSearch || '').includes(query))
          .forEach((card) => {
            card.hidden = false;
            if (searchGrid) searchGrid.appendChild(card);
            visibleCards += 1;
          });

        if (searchResults) searchResults.hidden = visibleCards === 0;
        if (empty) empty.hidden = visibleCards > 0;
        updateActiveFilter(query);
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (searchInput) searchInput.value = button.dataset.filterQuery || '';
          handleRecipeSearch();
        });
      });

      if (loadMoreButton) {
        loadMoreButton.hidden = recipesExpanded;
        loadMoreButton.addEventListener('click', () => {
          recipesExpanded = true;
          cards.forEach((card) => {
            card.hidden = false;
          });
          loadMoreButton.hidden = true;
        });
      }

      if (!recipesExpanded) {
        initiallyHiddenCards.forEach((card) => {
          card.hidden = true;
        });
      }

      if (searchInput) {
        searchInput.addEventListener('input', handleRecipeSearch);
        searchInput.addEventListener('search', handleRecipeSearch);
      }
    });
  };

  initCocoesRecipeIndexes();
  document.addEventListener('shopify:section:load', initCocoesRecipeIndexes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-showcase-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = 'collection-showcase-slider';

    class CollectionShowcaseSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.dots = this.querySelector('[data-slider-dots]');
        this.activeModal = null;
        this.lastTrigger = null;

        this.boundClick = this.handleClick.bind(this);
        this.boundKeydown = this.handleKeydown.bind(this);
        this.boundScroll = this.updateDots.bind(this);

        this.addEventListener('click', this.boundClick);
        this.addEventListener('keydown', this.boundKeydown);
        this.track?.addEventListener('scroll', this.boundScroll, { passive: true });
        this.querySelectorAll('[data-modal-gallery]').forEach((gallery) => {
          gallery.addEventListener('scroll', () => {
            this.updateModalGalleryDots(gallery);
            this.loadVisibleModalImages(gallery);
          }, { passive: true });
        });
        this.buildDots();
        this.updateDots();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundClick);
        this.removeEventListener('keydown', this.boundKeydown);
        this.track?.removeEventListener('scroll', this.boundScroll);
        document.removeEventListener('keydown', this.boundKeydown);
      }

      handleClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const close = target.closest('[data-modal-close]');
        if (close) {
          this.closeModal();
          return;
        }

        const addButton = target.closest('[data-add-to-cart]');
        if (addButton instanceof HTMLButtonElement) {
          event.preventDefault();
          event.stopPropagation();
          const modal = addButton.closest('[data-product-modal]');
          const variantInput = modal?.querySelector('[data-modal-variant]');
          const variantId = variantInput instanceof HTMLInputElement || variantInput instanceof HTMLSelectElement
            ? variantInput.value
            : addButton.dataset.variantId;
          const quantityInput = modal?.querySelector('[data-modal-quantity]');
          const quantity = quantityInput instanceof HTMLInputElement ? Number(quantityInput.value || 1) : 1;
          this.addToCart(variantId, quantity, addButton);
          return;
        }

        const variantSelect = target.closest('[data-modal-variant]');
        if (variantSelect instanceof HTMLSelectElement) {
          return;
        }

        const prev = target.closest('[data-slider-prev]');
        if (prev) {
          this.scrollByCard(-1);
          return;
        }

        const next = target.closest('[data-slider-next]');
        if (next) {
          this.scrollByCard(1);
          return;
        }

        const dot = target.closest('[data-slider-dot]');
        if (dot instanceof HTMLButtonElement) {
          this.scrollToIndex(Number(dot.dataset.sliderDot || 0));
          return;
        }

        const modalMediaDot = target.closest('[data-modal-media-dot]');
        if (modalMediaDot instanceof HTMLButtonElement) {
          const modal = modalMediaDot.closest('[data-product-modal]');
          const gallery = modal?.querySelector('[data-modal-gallery]');
          this.scrollModalGalleryToIndex(gallery, Number(modalMediaDot.dataset.modalMediaDotIndex || 0));
          return;
        }

        const modalMediaPrev = target.closest('[data-modal-media-prev]');
        if (modalMediaPrev instanceof HTMLButtonElement) {
          const modal = modalMediaPrev.closest('[data-product-modal]');
          const gallery = modal?.querySelector('[data-modal-gallery]');
          this.scrollModalGalleryBy(gallery, -1);
          modalMediaPrev.blur();
          return;
        }

        const modalMediaNext = target.closest('[data-modal-media-next]');
        if (modalMediaNext instanceof HTMLButtonElement) {
          const modal = modalMediaNext.closest('[data-product-modal]');
          const gallery = modal?.querySelector('[data-modal-gallery]');
          this.scrollModalGalleryBy(gallery, 1);
          modalMediaNext.blur();
          return;
        }

        const modalTrigger = target.closest('[data-modal-trigger]');
        if (modalTrigger) {
          const card = modalTrigger.closest('[data-product-card]');
          if (card instanceof HTMLElement) {
            this.openModal(card.dataset.modalId, card);
          }
          return;
        }

        if (target.closest('a, button, input, select, textarea, summary, details')) return;

        const card = target.closest('[data-product-card]');
        if (card instanceof HTMLElement) {
          this.openModal(card.dataset.modalId, card);
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.activeModal) {
          event.preventDefault();
          this.closeModal();
          return;
        }

        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        if ((event.key === 'Enter' || event.key === ' ') && target.matches('[data-product-card]')) {
          event.preventDefault();
          this.openModal(target.dataset.modalId, target);
        }
      }

      openModal(modalId, triggerElement) {
        const modal = modalId ? this.querySelector(`#${CSS.escape(modalId)}`) : null;
        if (!(modal instanceof HTMLElement)) return;

        this.lastTrigger = triggerElement;
        this.activeModal = modal;
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.remove('is-closing');
        document.body.classList.add('collection-showcase-modal-lock');
        document.addEventListener('keydown', this.boundKeydown);

        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const gallery = modal.querySelector('[data-modal-gallery]');
          if (gallery instanceof HTMLElement) {
            gallery.scrollTo({ left: 0 });
            this.loadModalImageAt(gallery, 0);
            this.updateModalGalleryDots(gallery);
          }
          const dialog = modal.querySelector('[data-modal-dialog]');
          if (dialog instanceof HTMLElement) dialog.focus({ preventScroll: true });
        });
      }

      loadVisibleModalImages(gallery) {
        if (!(gallery instanceof HTMLElement)) return;

        const activeIndex = this.getCurrentModalGalleryIndex(gallery);
        this.loadModalImageAt(gallery, activeIndex);
        this.loadModalImageAt(gallery, activeIndex + 1);
      }

      loadModalImageAt(gallery, index) {
        if (!(gallery instanceof HTMLElement)) return;

        const slides = Array.from(gallery.querySelectorAll('[data-modal-slide]'));
        const slide = slides[index];
        if (!(slide instanceof HTMLElement)) return;

        const image = slide.querySelector('[data-modal-lazy-image]');
        if (!(image instanceof HTMLImageElement) || image.dataset.loaded === 'true') return;

        if (image.dataset.srcset) image.srcset = image.dataset.srcset.replace(/\s+/g, ' ').trim();
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        if (image.dataset.src) image.src = image.dataset.src;
        image.dataset.loaded = 'true';
      }

      closeModal() {
        const modal = this.activeModal;
        if (!(modal instanceof HTMLElement)) return;

        modal.classList.remove('is-open');
        modal.classList.add('is-closing');

        const finish = () => {
          modal.setAttribute('aria-hidden', 'true');
          modal.classList.remove('is-closing');
          document.body.classList.remove('collection-showcase-modal-lock');
          document.removeEventListener('keydown', this.boundKeydown);
          this.activeModal = null;
          if (this.lastTrigger instanceof HTMLElement) {
            this.lastTrigger.focus({ preventScroll: true });
          }
        };

        const dialog = modal.querySelector('[data-modal-dialog]');
        if (dialog instanceof HTMLElement) {
          dialog.addEventListener('animationend', finish, { once: true });
        } else {
          finish();
        }
      }

      async addToCart(variantId, quantity, button) {
        if (!variantId || button.disabled) return;

        const text = button.querySelector('[data-button-text]');
        const error = button.parentElement?.querySelector('[data-cart-error]');
        const original = text?.textContent || 'Add to Cart';
        button.disabled = true;
        button.dataset.loading = 'true';
        if (text) text.textContent = 'Adding...';
        if (error) error.textContent = '';

        try {
          const normalizedQuantity = Math.max(1, Number(quantity) || 1);
          const sections = Array.from(document.querySelectorAll('cart-items-component'))
            .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : null)
            .filter(Boolean);

          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', String(normalizedQuantity));
          if (sections.length) {
            formData.append('sections', sections.join(','));
          }

          const root = window.Shopify?.routes?.root || '/';
          const addUrl = window.Theme?.routes?.cart_add_url || `${root}cart/add.js`;
          const cartUrl = window.Theme?.routes?.cart_url ? `${window.Theme.routes.cart_url}.js` : `${root}cart.js`;

          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const responseContentType = response.headers.get('content-type') || '';
          const data = responseContentType.includes('application/json')
            ? await response.json()
            : { status: response.status, message: await response.text() };

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || `Unable to add item (${response.status})`);
          }

          const cartResponse = await fetch(cartUrl, {
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.dataset.sectionId,
              data: {
                source: 'collection-showcase-slider',
                variantId: String(variantId),
                itemCount: normalizedQuantity,
                sections: data.sections || {}
              }
            }
          }));

          if (text) text.textContent = 'Added';
          window.setTimeout(() => {
            if (text) text.textContent = original;
          }, 1400);
        } catch (errorMessage) {
          if (text) text.textContent = 'Error';
          if (error) error.textContent = errorMessage?.message || 'Unable to add item';
          window.setTimeout(() => {
            if (text) text.textContent = original;
          }, 1600);
        } finally {
          button.disabled = false;
          button.dataset.loading = 'false';
        }
      }

      scrollByCard(direction) {
        if (!this.track) return;
        const cards = Array.from(this.track.querySelectorAll('[data-product-card]'));
        if (!cards.length) return;

        const currentScrollLeft = this.track.scrollLeft;
        const currentIndex = this.getCurrentCardIndex(cards);
        const targetPositions = cards.map((card) => card instanceof HTMLElement ? this.getCardScrollLeft(card) : 0);
        const tolerance = 8;
        let nextIndex = currentIndex;

        if (direction < 0) {
          nextIndex = targetPositions.reduce((targetIndex, position, index) => {
            return position < currentScrollLeft - tolerance ? index : targetIndex;
          }, 0);
        } else {
          nextIndex = targetPositions.findIndex((position) => position > currentScrollLeft + tolerance);
          if (nextIndex === -1) nextIndex = cards.length - 1;
        }

        this.scrollToIndex(nextIndex);
      }

      scrollToIndex(index) {
        if (!this.track) return;
        const cards = Array.from(this.track.querySelectorAll('[data-product-card]'));
        const card = cards[index];
        if (card instanceof HTMLElement) {
          this.track.scrollTo({
            left: this.getCardScrollLeft(card),
            behavior: 'smooth',
          });
        }
      }

      getCardScrollLeft(card) {
        if (!this.track || !(card instanceof HTMLElement)) return 0;

        const cardLeft = card.offsetLeft - this.track.offsetLeft;
        if (window.matchMedia('(max-width: 749px)').matches) {
          return cardLeft - ((this.track.clientWidth - card.offsetWidth) / 2);
        }

        return cardLeft;
      }

      getCurrentCardIndex(cards = Array.from(this.track?.querySelectorAll('[data-product-card]') || [])) {
        if (!this.track || !cards.length) return 0;

        const trackRect = this.track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        const distances = cards.map((card) => {
          if (!(card instanceof HTMLElement)) return Infinity;
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          return Math.abs(cardCenter - trackCenter);
        });

        return distances.indexOf(Math.min(...distances));
      }

      buildDots() {
        if (!this.dots || !this.track) return;
        const cards = Array.from(this.track.querySelectorAll('[data-product-card]'));
        this.dots.innerHTML = '';
        cards.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'collection-showcase__dot';
          dot.dataset.sliderDot = String(index);
          dot.setAttribute('aria-label', `Go to product ${index + 1}`);
          this.dots.appendChild(dot);
        });
      }

      updateDots() {
        if (!this.dots || !this.track) return;
        const cards = Array.from(this.track.querySelectorAll('[data-product-card]'));
        if (!cards.length) return;

        const activeIndex = this.getCurrentCardIndex(cards);

        this.dots.querySelectorAll('[data-slider-dot]').forEach((dot, index) => {
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }

      updateModalGalleryDots(gallery) {
        if (!(gallery instanceof HTMLElement)) return;

        const modal = gallery.closest('[data-product-modal]');
        const slides = Array.from(gallery.querySelectorAll('[data-modal-slide]'));
        const dots = Array.from(modal?.querySelectorAll('[data-modal-media-dot]') || []);
        if (!slides.length || !dots.length) return;

        const center = gallery.scrollLeft + gallery.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Infinity;
        slides.forEach((slide, index) => {
          if (!(slide instanceof HTMLElement)) return;
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(center - slideCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }

      getCurrentModalGalleryIndex(gallery) {
        if (!(gallery instanceof HTMLElement)) return 0;

        const slides = Array.from(gallery.querySelectorAll('[data-modal-slide]'));
        if (!slides.length) return 0;

        const center = gallery.scrollLeft + gallery.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Infinity;
        slides.forEach((slide, index) => {
          if (!(slide instanceof HTMLElement)) return;
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(center - slideCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      }

      scrollModalGalleryBy(gallery, direction) {
        if (!(gallery instanceof HTMLElement)) return;

        const slides = Array.from(gallery.querySelectorAll('[data-modal-slide]'));
        if (!slides.length) return;

        const currentIndex = this.getCurrentModalGalleryIndex(gallery);
        const nextIndex = Math.min(Math.max(currentIndex + direction, 0), slides.length - 1);
        this.scrollModalGalleryToIndex(gallery, nextIndex);
      }

      scrollModalGalleryToIndex(gallery, index) {
        if (!(gallery instanceof HTMLElement)) return;

        const slides = Array.from(gallery.querySelectorAll('[data-modal-slide]'));
        const slide = slides[index];
        if (slide instanceof HTMLElement) {
          this.loadModalImageAt(gallery, index);
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: window.matchMedia('(max-width: 749px)').matches ? 'center' : 'start'
          });
        }
      }
    }

    if (!customElements.get(SELECTOR)) {
      customElements.define(SELECTOR, CollectionShowcaseSlider);
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target?.querySelector?.(SELECTOR);
      if (section?.buildDots) {
        section.buildDots();
        section.updateDots();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
